import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AppLayout = _resolveComponent("AppLayout");

  return _openBlock(), _createBlock(_component_AppLayout);
}